import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth.guard';
import { PageNotFoundComponent } from 'src/app/page-not-found/components/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('src/app/home-page/home-page.module').then(m => m.HomePageModule) },
  { path: 'search', loadChildren: () => import('src/app/product-search/product-search.module').then(m => m.ProductSearchModule) },
  { path: 'product', loadChildren: () => import('src/app/product-detail/product-detail.module').then(m => m.ProductDetailModule) },
  { path: 'authentication', loadChildren: () => import('src/app/authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: 'cart', loadChildren: () => import('src/app/user-cart/user-cart.module').then(m => m.UserCartModule) },
  {
    path: 'checkout', loadChildren: () => import('src/app/checkout-shipping/checkout-shipping.module').then(m => m.CheckoutShippingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'order', loadChildren: () => import('src/app/order/order.module').then(m => m.OrderModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'account', loadChildren: () => import('src/app/my-account/my-account.module').then(m => m.MyAccountModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'contact-us', loadChildren: () => import('src/app/contact-us/contact-us.module').then(m => m.ContactUsModule)
  },
  {
    path: 'about-us', loadChildren: () => import('src/app/about-us/about-us.module').then(m => m.AboutUsModule)
  },
  {
    path: 'info/:type', loadChildren: () => import('src/app/store-information/store-information.module').then(m => m.StoreInformationModule)
  },
  {
    path: '**',
    loadChildren: () => import('src/app/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    scrollOffset: [0, 0],
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
